import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, Button, notification } from 'antd';
import './ItemRoomTypeModal.css';

const { Text } = Typography;
const { Search } = Input;

@inject('ItemRoomTypeStore')
@observer
class ItemRoomTypeModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON Search

    itemOnSearch = () => {
        this.props.ItemRoomTypeStore.setItemSearchValue('');
        this.props.ItemRoomTypeStore.searchItem();
        this.props.ItemRoomTypeStore.setShowItemSearchModal(true);
    }

    roomTypeOnSearch = () => {
        this.props.ItemRoomTypeStore.setRoomTypeSearchValue('');
        this.props.ItemRoomTypeStore.searchRoomType();
        this.props.ItemRoomTypeStore.setShowRoomTypeSearchModal(true);
    }

    // ON CLICK

    createOrUpdateItemRoomTypeOnClick = () => {
        const { itemRoomTypeId } = this.props.ItemRoomTypeStore;
        if (itemRoomTypeId === 0) {
            this.props.ItemRoomTypeStore.createItemRoomType().then(response => {
                if (!response.isError) {
                    notification['success']({
                        message: 'Success',
                        description: 'Item Room Type has been successfully created.',
                        duration: 3
                    });
                    this.props.ItemRoomTypeStore.initItemRoomType();
                } else {
                    notification['error']({
                        message: 'Error',
                        description: response.errorMessage,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.ItemRoomTypeStore.updateItemRoomType().then(response => {
                if (!response.isError) {
                    notification['success']({
                        message: 'Success',
                        description: 'Item Room Type has been successfully updated.',
                        duration: 3
                    });
                    this.props.ItemRoomTypeStore.initItemRoomType();
                } else {
                    notification['error']({
                        message: 'Error',
                        description: response.errorMessage,
                        duration: 3
                    });
                }
            });
        }
    }

    render() {
        const {
            taskName,
            roomTypeName,
            itemRoomTypeTextButton,
            itemRoomTypeModalLoading
        } = this.props.ItemRoomTypeStore;

        let addOrUpdateItemRoomTypeDisable = false;
        if (taskName === '' || roomTypeName === '') {
            addOrUpdateItemRoomTypeDisable = true;
        }

        return (
            <Spin spinning={itemRoomTypeModalLoading}>
                <Row className='itemroomtypemodal-row-container'>
                    <Col span={24} className='itemroomtypemodal-col'>
                        <Row>
                            <Col span={8} className='itemroomtypemodal-col-label'>
                                <Text className='itemroomtypemodal-text-label'>Item<Text className='itemroomtypemodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='itemroomtypemodal-col-input'>
                                <Search
                                    placeholder='Search item'
                                    value={taskName}
                                    onSearch={this.itemOnSearch}
                                    enterButton
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='itemroomtypemodal-col'>
                        <Row>
                            <Col span={8} className='itemroomtypemodal-col-label'>
                                <Text className='itemroomtypemodal-text-label'>Room Type<Text className='itemroomtypemodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='itemroomtypemodal-col-input'>
                                <Search
                                    placeholder='Search room type'
                                    value={roomTypeName}
                                    onSearch={this.roomTypeOnSearch}
                                    enterButton
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='itemroomtypemodal-col-button'>
                        <Button disabled={addOrUpdateItemRoomTypeDisable} type='primary' className='itemroomtypemodal-button' onClick={this.createOrUpdateItemRoomTypeOnClick}>{itemRoomTypeTextButton}</Button>
                    </Col>
                </Row>
            </Spin >
        )
    }
}

export default ItemRoomTypeModalPage;